export default function IosReverseCamera() {
  return (
    <div
      className="ion-icon-ios-reverse-camera"
      dangerouslySetInnerHTML={{
        __html: `<?xml version="1.0" encoding="utf-8"?>
<!-- Generator: Adobe Illustrator 16.2.1, SVG Export Plug-In . SVG Version: 6.00 Build 0)  -->
<!DOCTYPE svg PUBLIC "-//W3C//DTD SVG 1.1//EN" "http://www.w3.org/Graphics/SVG/1.1/DTD/svg11.dtd">
<svg version="1.1" id="Layer_1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px"
	 width="512px" height="512px" viewBox="0 0 512 512" enable-background="new 0 0 512 512" xml:space="preserve">
<g>
	<path d="M417.5,160h-61.725c-32.105-36-42.219-48-54.525-48h-88.5c-12.314,0-22.167,12-54.521,48H145v-16h-34v16H97.5
		C79.855,160,64,173.217,64,190.684v176.018C64,384.169,79.855,400,97.5,400h320c17.645,0,30.5-15.831,30.5-33.299V190.684
		C448,173.217,435.145,160,417.5,160z M313.076,330.782C297.17,344.434,276.9,352,256,352c-45.487,0-82.509-36-87.205-78h-29.479
		l37.534-50l38.87,50h-30.61c4.604,33,34.53,61.965,70.89,61.965c16.859,0,32.701-6.327,45.815-17.356l2.032-1.647l11.599,11.662
		L313.076,330.782z M335.094,307.225L296.248,256h30.644c-4.617-35-34.548-63.797-70.891-63.797
		c-16.618,0-32.888,6.133-45.814,17.005l-2.033,1.706l-11.599-11.61l2.371-2.052c15.905-13.65,36.175-21.206,57.075-21.206
		c22.333,0,43.548,8.063,59.736,22.839C331.275,213.064,340.966,236,343.207,256h29.512L335.094,307.225z"/>
</g>
</svg>
`,
      }}
    />
  )
}
